import React from 'react';
import PropTypes from 'prop-types';

import withAuthenticator from 'HOCs/withAuthenticator';
import OlympicPractice from 'modules/Olympic/components/OlympicPractice';
import OlympicPracticeDefault from 'modules/Olympic/components/OlympicPractice/OlympicPracticeDefault';
import { permission } from 'constants/auth';

const Practice = ({ loggedInUser }) => {
  const isAccess = permission.includes(loggedInUser.email);
  return (
    <React.Fragment>
      {isAccess ? <OlympicPractice loggedInUser={loggedInUser} /> : <OlympicPracticeDefault />}
    </React.Fragment>
  );
};

Practice.propTypes = {
  loggedInUser: PropTypes.object.isRequired,
};

export default withAuthenticator(Practice);
